import { Input } from "reactstrap";

function FuncaoGeral({ params, onChange }) {
  return (
    <div>
      <div className="params-section">
        <div className="params-field">
          <label>Titulo Principal :</label>
          <Input
            onChange={({ target }) => onChange("title", target.value)}
            type="text"
            value={params.type.title}
          />
          <span
            style={{
              fontSize: 8,
              fontStyle: "italic",
              color: "red",
              fontWeight: "500",
            }}
          >
            Esse titulo não pode ser editado pelo usuário, ele fica no topo da
            Função renderizada no workflow.
          </span>
        </div>
        <div className="params-field">
          <label>Icone:</label>
          <div
            style={{
              display: "flex",
              gap: 10,
            }}
          >
            <img
              className="border"
              src={params?.type?.icon}
              style={{ width: 70, height: 70 }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: -10,
                width: "100%",
              }}
            >
              <label>
                <span style={{ fontSize: 10 }}>URL da Imagem:</span>
              </label>
              <Input
                onChange={({ target }) => onChange("icon", target.value)}
                type="text"
                value={params?.type?.icon}
              />
            </div>
          </div>
        </div>
        <div className="params-field mt-2">
          <label>Descrição da Função:</label>
          <Input
            onChange={({ target }) => onChange("description", target.value)}
            type="textarea"
            style={{ minHeight: 80 }}
            value={params.type.description}
          />
        </div>

        {/* <div className="params-field" style={{ paddingBottom: 10 }}>
          <label>Enum de Tipo:</label>
          <Input type="text" value={params.type.type} />
        </div> */}
      </div>
    </div>
  );
}

export default FuncaoGeral;
